(() => {
  const storageKey = 'frostpeak:wishlist:v3';
  const qs = (s, root = document) => root.querySelector(s);
  const qsa = (s, root = document) => [...root.querySelectorAll(s)];
  const fr = (document.documentElement.lang || 'fr').toLowerCase().startsWith('fr');

  const read = () => {
    try {
      const value = JSON.parse(localStorage.getItem(storageKey) || '[]');
      return Array.isArray(value) ? value : [];
    } catch (_) { return []; }
  };
  const write = (items) => {
    try { localStorage.setItem(storageKey, JSON.stringify(items)); } catch (_) {}
  };
  const esc = (v = '') => String(v).replaceAll('&','&amp;').replaceAll('<','&lt;').replaceAll('>','&gt;').replaceAll('"','&quot;').replaceAll("'",'&#039;');

  const productFrom = (scope) => {
    const script = qs('[data-wishlist-product-json]', scope);
    if (!script) return null;
    try { return JSON.parse(script.textContent); } catch (_) { return null; }
  };

  const card = (item) => `
    <article class="wishlist-card" data-wishlist-id="${esc(item.id)}">
      <a class="wishlist-card__image" href="${esc(item.url)}">${item.image ? `<img src="${esc(item.image)}" alt="${esc(item.title)}" loading="lazy">` : ''}</a>
      <div class="wishlist-card__content">
        <h3><a href="${esc(item.url)}">${esc(item.title)}</a></h3>
        ${item.variant_title ? `<p>${esc(item.variant_title)}</p>` : ''}
        ${item.price_formatted ? `<strong>${esc(item.price_formatted)}</strong>` : ''}
        <span>${item.available ? (fr ? 'En stock' : 'In stock') : (fr ? 'Épuisé' : 'Sold out')}</span>
        <div class="wishlist-card__actions">
          ${item.available && Number(item.price) > 0 ? `<button class="button button--secondary button--small" type="button" data-wishlist-add="${esc(item.variant_id)}">${fr ? 'Ajouter' : 'Add'}</button>` : ''}
          <button class="link-button" type="button" data-wishlist-remove="${esc(item.id)}">${fr ? 'Retirer' : 'Remove'}</button>
        </div>
      </div>
    </article>`;

  const update = () => {
    const items = read();
    qsa('[data-wishlist-count]').forEach((el) => {
      el.textContent = items.length;
      el.hidden = items.length === 0;
    });
    qsa('[data-wishlist-product]').forEach((scope) => {
      const item = productFrom(scope);
      if (!item) return;
      const active = items.some((entry) => String(entry.id) === String(item.id));
      qsa('[data-wishlist-toggle]', scope).forEach((button) => {
        button.classList.toggle('is-active', active);
        button.setAttribute('aria-pressed', String(active));
      });
    });
    qsa('[data-wishlist-items]').forEach((el) => {
      el.innerHTML = items.length ? items.map(card).join('') : `<div class="empty-state"><p>${fr ? 'Votre liste de favoris est vide.' : 'Your wishlist is empty.'}</p></div>`;
    });
    qsa('[data-wishlist-page]').forEach((el) => { el.innerHTML = items.map(card).join(''); });
    qsa('[data-wishlist-empty]').forEach((el) => { el.hidden = items.length !== 0; });
  };

  const open = () => {
    const drawer = qs('[data-wishlist-drawer]');
    if (!drawer) return;
    update();
    drawer.setAttribute('aria-hidden','false');
    document.body.classList.add('wishlist-open');
    qs('[data-wishlist-close]', drawer)?.focus();
  };
  const close = () => {
    const drawer = qs('[data-wishlist-drawer]');
    if (!drawer) return;
    drawer.setAttribute('aria-hidden','true');
    document.body.classList.remove('wishlist-open');
  };

  const addCart = async (variantId) => {
    const response = await fetch(window.FrostPeak.routes.cartAdd, {
      method:'POST',
      headers:{'Content-Type':'application/json',Accept:'application/json'},
      body:JSON.stringify({items:[{id:Number(variantId),quantity:1}]})
    });
    if (!response.ok) throw new Error('Cart error');
    const cart = await fetch(`${window.FrostPeak.routes.cart}.js`).then((r) => r.json());
    qsa('[data-cart-count]').forEach((el) => {
      el.textContent = cart.item_count;
      el.hidden = cart.item_count === 0;
    });
  };

  document.addEventListener('click', async (event) => {
    const toggle = event.target.closest('[data-wishlist-toggle]');
    if (toggle) {
      event.preventDefault();
      const scope = toggle.closest('[data-wishlist-product]');
      const item = productFrom(scope);
      if (!item) return;
      const items = read();
      const index = items.findIndex((entry) => String(entry.id) === String(item.id));
      if (index >= 0) items.splice(index,1); else items.unshift(item);
      write(items.slice(0,100));
      update();
      return;
    }
    if (event.target.closest('[data-wishlist-open]')) { event.preventDefault(); open(); return; }
    if (event.target.closest('[data-wishlist-close]')) { close(); return; }
    const remove = event.target.closest('[data-wishlist-remove]');
    if (remove) { write(read().filter((item) => String(item.id) !== String(remove.dataset.wishlistRemove))); update(); return; }
    if (event.target.closest('[data-wishlist-clear]')) { write([]); update(); return; }
    const add = event.target.closest('[data-wishlist-add]');
    if (add) {
      add.disabled = true;
      try { await addCart(add.dataset.wishlistAdd); } finally { add.disabled = false; }
    }
  });

  document.addEventListener('keydown', (event) => {
    if (event.key === 'Escape') close();
  });

  document.addEventListener('DOMContentLoaded', update);
  document.addEventListener('shopify:section:load', update);
  update();
})();